import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import championRoles from "constants/champions/championRoles.json";
import topIcon from "styles/images/roles/top.webp";
import jungleIcon from "styles/images/roles/jungle.webp";
import midIcon from "styles/images/roles/middle.webp";
import bottomIcon from "styles/images/roles/bottom.webp";
import supportIcon from "styles/images/roles/support.webp";
import findIcon from "styles/images/views/game/find.svg";
import { Tooltip } from "react-tooltip";
import { isMobile } from "react-device-detect";

function RoleFilter({ initialChampionsList, setFilteredChampionsList }) {
  const [searchText, setSearchText] = useState("");
  const [activeRole, setActiveRole] = useState(null);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleReinitChampions = () => {
    setFilteredChampionsList(initialChampionsList);
    setSearchText("");
  };

  useEffect(() => {
    if (initialChampionsList.size > 0) {
      const filtered = new Map(
        [...initialChampionsList.entries()].filter(
          ([, champion]) =>
            champion.name.toLowerCase().includes(searchText.toLowerCase()) ||
            champion.id.toLowerCase().includes(searchText.toLowerCase()),
        ),
      );
      setFilteredChampionsList(filtered);
    }
  }, [searchText]);

  const setChampionsByRole = (role) => {
    const championsByRole = [...initialChampionsList.values()].filter(
      (champion) => {
        if (!championRoles[champion.id]) {
          console.warn(
            `Champion with id ${champion.id} does not exist in the list.`,
          );
          return false;
        }
        return championRoles[champion.id][role] === "Yes";
      },
    );
    setFilteredChampionsList(championsByRole);
  };

  const handleRolePick = (role) => {
    handleReinitChampions();

    if (activeRole === role) {
      setActiveRole(null);
    } else {
      setActiveRole(role);
      if (role !== "Fill") setChampionsByRole(role);
    }
  };

  const roleButtons = [
    {
      role: "Top",
      imageSrc: topIcon,
    },
    {
      role: "Jungle",
      imageSrc: jungleIcon,
    },
    {
      role: "Middle",
      imageSrc: midIcon,
    },
    {
      role: "Bottom",
      imageSrc: bottomIcon,
    },
    {
      role: "Support",
      imageSrc: supportIcon,
    },
  ];

  return (
    <div className="RoleFilter">
      <div className="rolePickerContainer">
        {roleButtons.map((button) => (
          <React.Fragment key={button.role}>
            <motion.button
              key={button.role}
              className={`rolePickerCard ${
                activeRole === button.role ? "active" : ""
              }`}
              onClick={() => handleRolePick(button.role)}
              data-tooltip-id={`${button.role}-tooltip`}
              data-tooltip-content={button.role}
            >
              <img
                alt={`position ${button.role.toLowerCase()}`}
                src={button.imageSrc}
              />
            </motion.button>
            <Tooltip id={`${button.role}-tooltip`} type="dark" place="left" />
          </React.Fragment>
        ))}
      </div>
      <div className="rolePickerTextInputContainer">
        <input
          type="text"
          value={searchText}
          onChange={handleSearchChange}
          placeholder={searchText === "" ? "Search Champion" : ""}
          className="rolePickerTextInput"
        />
        {!isMobile && <img src={findIcon} alt="find Champion icon" />}
      </div>
    </div>
  );
}

export default RoleFilter;
